import React, { useState } from 'react';
import { Button, Card, Space, message } from 'antd';
import { useDebugInfo } from '../../hooks/useDebugInfo';
import api from '../../services/api';

const DebugTest: React.FC = () => {
  const { debugMode, log, logApiRequest, logApiResponse, logApiError, logUserAction } = useDebugInfo('DebugTest');
  const [loading, setLoading] = useState(false);

  const testApiCall = async () => {
    setLoading(true);
    try {
      logUserAction('test-api-call-start');
      logApiRequest('/test-endpoint', 'GET');
      
      // 模拟一个会失败的API调用
      const response = await api.get('/non-existent-endpoint');
      logApiResponse('/test-endpoint', response.data, response.status);
      
    } catch (error: any) {
      logApiError('/test-endpoint', error);
      logUserAction('test-api-call-error', { error: error.message });
      message.error('测试API调用失败（这是预期的）');
    } finally {
      setLoading(false);
    }
  };

  const testFormData = () => {
    log('test-form-data', {
      step1: { name: '测试服务器', gameType: 'Minecraft' },
      step2: { node: 'Node1', port: 27020, maxPlayers: 20 },
      step3: { duration: 7, price: 35 }
    });
    message.success('测试表单数据已记录');
  };

  const testError = () => {
    try {
      throw new Error('这是一个测试错误');
    } catch (error: any) {
      log('test-error', {
        message: error.message,
        stack: error.stack,
        timestamp: new Date().toISOString()
      });
      message.success('测试错误已记录');
    }
  };

  return (
    <Card title="调试功能测试" className="mb-4">
      <div className="space-y-4">
        <div>
          <strong>调试模式状态:</strong> {debugMode ? '开启' : '关闭'}
        </div>
        
        <Space wrap>
          <Button 
            type="primary" 
            onClick={testApiCall}
            loading={loading}
          >
            测试API调用（会失败）
          </Button>
          
          <Button onClick={testFormData}>
            测试表单数据记录
          </Button>
          
          <Button onClick={testError}>
            测试错误记录
          </Button>
        </Space>
        
        <div className="text-sm text-gray-600">
          <p>使用说明：</p>
          <ul className="list-disc list-inside space-y-1">
            <li>点击按钮测试不同的调试功能</li>
            <li>使用 Ctrl+Shift+D 切换调试模式</li>
            <li>点击右上角的调试按钮查看调试面板</li>
            <li>在调试面板中查看记录的调试信息</li>
          </ul>
        </div>
      </div>
    </Card>
  );
};

export default DebugTest;
